import React from 'react';
import { connect } from 'react-redux'
import { branch, compose, renderComponent } from 'recompose'
import { usersActions, usersSelectors} from './redux'
import { careUnitActions, careUnitSelectors } from '../careUnit/redux'
import { opticianActions, opticianSelectors } from '../optician/redux'
import { sessionSelectors } from '../session/redux'
import lifeCycle from './UserListLifecycle'
import UserList from "./UserList";
import Loading from '../../components/Loading'

const mapStateToProps = (state) => ({
    users: usersSelectors.userList(state),
    createDialogOpen: usersSelectors.createDialogOpen(state),
    updateDialogOpen: usersSelectors.updateDialogOpen(state),
    careUnits: careUnitSelectors.careUnitList(state),
    opticians: opticianSelectors.opticianList(state),
    username: usersSelectors.username(state),
    role: usersSelectors.role(state),
    organizationId: usersSelectors.organizationId(state),
    saveUserError: usersSelectors.saveUserError(state),
    loggedInUser: sessionSelectors.loggedInUser(state),
    loggedInUserRole: sessionSelectors.role(state),
    loggedInUserOrganizationId: sessionSelectors.organizationId(state),
    isLoading: usersSelectors.isLoading(state),
    resetPasswordSuccess: usersSelectors.resetPasswordSuccess(state),
    userForm: usersSelectors.userForm(state),
});

const mapDispatchToProps = (dispatch) => ({
    listUsers: () => dispatch(usersActions.listUsers()),
    loadCareUnits: () => dispatch(careUnitActions.listCareUnits()),
    loadOpticians: () => dispatch(opticianActions.listOpticians()),
    updateUserClicked: (user) => dispatch(usersActions.openUpdateDialog(user)),
    addUserClicked: () => dispatch(usersActions.openCreateDialog()),
    closeDialogClicked: () => dispatch(usersActions.closeDialogs()),
    createUser: (username, role, email, organizationId, password, retypePassword) => dispatch(usersActions.createUser(username, role, email, organizationId, password, retypePassword)),
    updateUser: (username, role, email, organizationId) => dispatch(usersActions.updateUser(username, role, email, organizationId)),
    deleteUser: (username) => dispatch(usersActions.deleteUser(username)),
    resetUserPassword: (username) => dispatch(usersActions.resetUserPassword(username)),
});

export default compose (
    connect(mapStateToProps, mapDispatchToProps),
    lifeCycle,
    branch(
        ({ isLoading, users, saveUserError, createDialogOpen, updateDialogOpen }) =>
            (isLoading || (!users && !saveUserError)) && !createDialogOpen && !updateDialogOpen,
        renderComponent(() => <Loading title={"Laddar..."} />)
    )
)(UserList)